import Resizer from 'react-image-file-resizer'
import {Config} from '../../constants/Config'

export const img2CompressedWebp = (file: Blob): Promise<File> =>
  new Promise(resolve => {
    Resizer.imageFileResizer(
      file,
      Config.imageCompressionResolution,
      Config.imageCompressionResolution,
      Config.imageCompressionFormat,
      Config.imageCompressionQuality,
      0,
      uri => {
        resolve(uri as File)
      },
      'file',
      800,
      800,
    )
  })
